import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomStep, Tick, AvailableRange } from 'marketpro-design-lib';
import { RangeFilter } from '../../../models/custom-filter-range.model';

@Component({
  selector: 'mpro-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss'],
})
export class DialogBoxComponent implements OnInit {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() min: number;
  @Input() max: number;
  @Input() rangeFilter: RangeFilter;
  @Input() step: number = 5;
  @Input() minInterval: number = 5;
  @Input() customSteps: CustomStep[] = [];
  @Input() authRanges?: AvailableRange[];
  @Input() customTicks: Tick[] = [];
  @Input() inputTitle?: string;
  @Input() dynamicRange = false;

  name: string = '';
  inputState: 'default' | 'error' = 'default';
  public error: string | undefined = undefined;
  @Input() public labelFormat: (label: string) => string;
  @Input() public sliderFormat: (sliderValue: string) => string;
  @Input() public valueFormat: (sliderValue: number) => number | undefined;

  @Output() save = new EventEmitter();
  @Output() preview = new EventEmitter();
  @Output() cancel = new EventEmitter();

  ngOnInit(): void {
    if (!this.rangeFilter.greaterThan && !this.rangeFilter.lessThan) {
      this.rangeFilter = new RangeFilter('', this.min, this.max);
    }

    if (!this.labelFormat) {
      this.labelFormat = (label) => {
        return label === this.max.toString() ? `>${this.max - 1}` : label;
      };
    }

    if (!this.sliderFormat) {
      this.sliderFormat = (sliderVal) => {
        return this.labelFormat(sliderVal);
      };
    }

    if (!this.valueFormat) {
      let valuesConsideredUndefined: number[] = [];
      this.customSteps.forEach((cs) => {
        if (cs.considerFromValueAsUndefined) {
          valuesConsideredUndefined.push(cs.from);
        }
        if (cs.considerToValueAsUndefined) {
          valuesConsideredUndefined.push(cs.to);
        }
      });
      this.valueFormat = (val) =>
        valuesConsideredUndefined.includes(val) ? undefined : val;
    }
  }

  public sliderChanged(range: (number | undefined)[]): void {
    this.rangeFilter.greaterThan = range[0];
    this.rangeFilter.lessThan = range[1];
  }

  keyup() {
    this.inputState = 'default';
  }

  saveClick() {
    if (this.error) {
      return;
    }

    if (this.name.length > 12) {
      this.inputState = 'error';
      return;
    }

    this.save.emit(this.rangeFilter);
  }

  public previewGroup(): void {
    this.preview.emit(this.rangeFilter);
  }

  cancelClick() {
    this.cancel.emit();
  }

  onErrorChanged(error: string | undefined) {
    this.error = error;
  }
}
